function digits(value) {
  return String(value).split("").map(Number);
}

export function divisionRemainderCells(row, columnShift = 0) {
  return {
    digits: String(row.remainderText).split(""),
    offset: row.resultStart + columnShift + 2,
  };
}

export function analyzeWrittenDivision(dividend, divisor) {
  const dividendDigits = digits(dividend);
  let current = 0;
  let quotientText = "";
  const quotientDigits = Array(dividendDigits.length).fill(" ");
  const rows = [];
  const detailLines = [];
  const steps = [];

  dividendDigits.forEach((digit, idx) => {
    current = current * 10 + digit;
    const quotientDigit = Math.floor(current / divisor);
    const product = quotientDigit * divisor;
    const remainder = current - product;
    const skipped = quotientDigit === 0 && quotientText === "";
    const hasNextDigit = idx + 1 < dividendDigits.length;

    if (!skipped) {
      quotientText += String(quotientDigit);
      quotientDigits[idx] = String(quotientDigit);
    } else {
      quotientDigits[idx] = "=";
    }

    detailLines.push({ current, quotientDigit, product, remainder, skipped });

    if (!skipped) {
      const nextDigit = hasNextDigit ? dividendDigits[idx + 1] : null;
      const currentLength = String(current).length;
      const remainderPadded = String(remainder).padStart(currentLength, "=");
      const remainderText =
        nextDigit == null
          ? String(remainder).padStart(currentLength, " ")
          : `${remainderPadded}${nextDigit}`;
      rows.push({
        current,
        quotientDigit,
        product,
        remainder,
        remainderText: remainderText || "0",
        start: idx - String(current).length + 1,
        resultStart: idx - currentLength + 1,
      });
    }

    steps.push({
      dividend,
      divisor,
      quotientText: quotientText || " ",
      quotientDigits: [...quotientDigits],
      activeQuotientIndex: idx,
      rows: rows.map((row) => ({ ...row })),
      activeRow: skipped ? null : rows.length - 1,
      activeKind: skipped ? "skip" : "subtract",
    });

    current = remainder;
  });

  steps.push({
    dividend,
    divisor,
    quotientText: quotientText || "0",
    quotientDigits: quotientDigits.map((digit) => (digit === "=" ? " " : digit)),
    activeQuotientIndex: null,
    rows: rows.map((row) => ({ ...row })),
    activeRow: null,
    activeKind: "final",
  });

  return {
    quotient: Number(quotientText || "0"),
    remainder: current,
    detailLines,
    steps,
  };
}
